// Canonical Prior Auth status maps — single source of truth for the PA table
// chips and the Settings → Action Needed labels. Statuses persist as display
// strings ("Requires review"); Settings stores enum keys ("REQUIRES_REVIEW").

export const WAITING_ON_PAYER_DISPLAY = "Waiting on payer";

export const PA_STATUS_VALUE_BY_KEY = {
  INITIATED: "Initiated",
  CREATED: "Created",
  INCOMPLETE: "Incomplete",
  NOT_SUPPORTED: "Payor/Medication not supported",
  REQUIRES_REVIEW: "Requires review",
  DEMOGRAPHICS_REVIEW: "Review demographics info",
  PROCESSING: "Processing",
  // Key must equal backend WAITING_ON_PAYER_STATUS_KEY.
  WAITING_ON_PAYER: WAITING_ON_PAYER_DISPLAY,
  CLINICAL_REVIEW: "Review clinical info",
  SENT_TO_PLAN: "Sent to plan",
  SENT_TO_PRESCRIBER: "Sent to prescriber",
  APPROVED: "Approved",
  RESPONSE_RECEIVED: "Response received",
  DENIED: "Denied",
  ARCHIVED: "Archived",
  NO_PAYOR_RESPONSE_RECEIVED: "No payor response received",
  REQUIRES_MORE_INFORMATION: "Requires more information",
  PA_NOT_REQUIRED: "Prior authorization not required",
};

// CMM statuses where the submission can be re-opened (edit + resubmit).
export const CMM_REOPENABLE_STATUSES = [
  "Payor/Medication not supported",
  "Response received",
  "Requires more information",
];

export const PA_STATUS_MAP = {
  Processing: { label: "Processing", color: "error" },
  [WAITING_ON_PAYER_DISPLAY]: { label: WAITING_ON_PAYER_DISPLAY, color: "warning" },
  Created: { label: "Fetching Questions", color: "error" },
  "Sent to prescriber": { label: "Sent to Prescriber", color: "warning" },
  "Sent to plan": { label: "Sent to Plan", color: "success" },
  "Response received": { label: "Response Received", color: "success" },
  Denied: { label: "Denied", color: "error" },
  Incomplete: { label: "Incomplete", color: "warning" },
  Approved: { label: "Approved", color: "success" },
  Initiated: { label: "Initiated", color: "warning" },
  "Requires more information": { label: "Requires More Info", color: "warning" },
  "No payor response received": { label: "No Payor Response", color: "warning" },
  "Payor/Medication not supported": { label: "Not Supported", color: "error" },
  "Requires review": { label: "Requires Review", color: "info" },
  "Review demographics info": { label: "Demographics Review", color: "info" },
  "Review clinical info": { label: "Clinical Review", color: "info" },
  Archived: { label: "Archived", color: "secondary" },
  "Prior authorization not required": { label: "PA Not Required", color: "info" },
};

// Enum key → display label, derived so Settings toggles read the same labels as the table chips.
export const PA_STATUS_LABEL_BY_KEY = Object.fromEntries(
  Object.entries(PA_STATUS_VALUE_BY_KEY).map(([key, value]) => [key, PA_STATUS_MAP[value]?.label ?? value])
);

export const PAYER_WAIT_PIPELINE_STEPS = new Set(["Fetch Payor Response", "Repeat Polling for Definitive Response"]);

export function resolvePaDisplayStatus(status, pipelineStep) {
  if (status === PA_STATUS_VALUE_BY_KEY.PROCESSING && PAYER_WAIT_PIPELINE_STEPS.has(pipelineStep)) {
    return WAITING_ON_PAYER_DISPLAY;
  }
  return status;
}
